// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Formality from "../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as OrderStatus from "../../../../../../../library/data-source/order/entity/OrderStatus.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";

function isMsisdnEnabled(orderStatue) {
  return orderStatue < 2;
}

function isOrderStatusEnabled(orderStatue) {
  return orderStatue < 7;
}

function isActualTripAcceptTimeEnabled(orderStatue) {
  return orderStatue < 2;
}

function isActualTripStartTimeEnabled(orderStatue) {
  return orderStatue < 3;
}

function isEndTimeEnabled(orderStatue) {
  return orderStatue < 6;
}

function isCompletedTimeEnabled(orderStatue) {
  return orderStatue === 6;
}

function isManualUpdateReasonEnabled(orderStatue) {
  return orderStatue < 7;
}

function makeUpdateOrderStatusSelectComponentList(data) {
  return List.map((function (reason) {
                return {
                        key: reason.key,
                        value: reason.value,
                        text: reason.text
                      };
              }), data);
}

function getUpdateOrderStatusSelectData(orderStatus) {
  switch (orderStatus) {
    case /* Open */0 :
        return {
                hd: {
                  key: "open",
                  value: "open",
                  text: "open"
                },
                tl: {
                  hd: {
                    key: "ended",
                    value: "ended",
                    text: "ended"
                  },
                  tl: /* [] */0
                }
              };
    case /* Allocated */1 :
        return {
                hd: {
                  key: "allocated",
                  value: "allocated",
                  text: "allocated"
                },
                tl: {
                  hd: {
                    key: "ended",
                    value: "ended",
                    text: "ended"
                  },
                  tl: /* [] */0
                }
              };
    case /* Accepted */2 :
        return {
                hd: {
                  key: "accepted",
                  value: "accepted",
                  text: "accepted"
                },
                tl: {
                  hd: {
                    key: "ended",
                    value: "ended",
                    text: "ended"
                  },
                  tl: /* [] */0
                }
              };
    case /* Live */3 :
    case /* Loading */4 :
    case /* Unloading */5 :
        return {
                hd: {
                  key: "live",
                  value: "live",
                  text: "live"
                },
                tl: {
                  hd: {
                    key: "ended",
                    value: "ended",
                    text: "ended"
                  },
                  tl: /* [] */0
                }
              };
    case /* Ended */6 :
        return {
                hd: {
                  key: "ended",
                  value: "ended",
                  text: "ended"
                },
                tl: {
                  hd: {
                    key: "completed",
                    value: "completed",
                    text: "completed"
                  },
                  tl: /* [] */0
                }
              };
    case /* Completed */7 :
        return {
                hd: {
                  key: "completed",
                  value: "completed",
                  text: "completed"
                },
                tl: /* [] */0
              };
    case /* Cancelled */8 :
        return {
                hd: {
                  key: "cancelled",
                  value: "cancelled",
                  text: "cancelled"
                },
                tl: /* [] */0
              };
    case /* Rescheduled */9 :
        return {
                hd: {
                  key: "rescheduled",
                  value: "rescheduled",
                  text: "rescheduled"
                },
                tl: /* [] */0
              };
    
  }
}

function getOrderStatusDropdownItem(value, orderStatus) {
  return SelectComponent$Catalyst.getSelectedItem(value, getUpdateOrderStatusSelectData(orderStatus));
}

var validators_manualUpdateReason = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var manualUpdateReason = param.manualUpdateReason;
      if (metadata.isFormActive && metadata.orderStatus < 7) {
        if (manualUpdateReason !== undefined) {
          return {
                  TAG: /* Ok */0,
                  _0: manualUpdateReason.key
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Please select manual update reason"
                };
        }
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_tripCompletedTime = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var tripCompletedTime = param.tripCompletedTime;
      var tripEndTime = param.tripEndTime;
      if (!(metadata.isFormActive && metadata.orderStatus === 6)) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      if (tripCompletedTime === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please enter actual trip complete time"
              };
      }
      if (tripEndTime === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please enter trip end time first"
              };
      }
      var value = Caml_option.valFromOption(tripCompletedTime);
      if (Caml_obj.caml_lessequal(value, Caml_option.valFromOption(tripEndTime))) {
        return {
                TAG: /* Error */1,
                _0: "Complete trip time should be greater than ended time"
              };
      } else if (Caml_obj.caml_greaterthan(value, metadata.currentTime)) {
        return {
                TAG: /* Error */1,
                _0: "Complete trip time cannot be future time"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(value)
              };
      }
    })
};

var validators_tripEndTime = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var tripEndTime = param.tripEndTime;
      var actualTripStartTime = param.actualTripStartTime;
      if (!(metadata.isFormActive && metadata.orderStatus < 6)) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      if (tripEndTime === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please enter actual trip end time"
              };
      }
      if (actualTripStartTime === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please enter start trip time first"
              };
      }
      var value = Caml_option.valFromOption(tripEndTime);
      if (Caml_obj.caml_lessequal(value, Caml_option.valFromOption(actualTripStartTime))) {
        return {
                TAG: /* Error */1,
                _0: "End trip time should be greater than start time"
              };
      } else if (Caml_obj.caml_greaterthan(value, metadata.currentTime)) {
        return {
                TAG: /* Error */1,
                _0: "End trip time cannot be future time"
              };
      } else if (Caml_obj.caml_lessthan(value, metadata.order.created_at)) {
        return {
                TAG: /* Error */1,
                _0: "Trip end time cannot be less than order created time"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(value)
              };
      }
    })
};

var validators_actualTripStartTime = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var actualTripStartTime = param.actualTripStartTime;
      var actualTripAcceptTime = param.actualTripAcceptTime;
      if (!(metadata.isFormActive && metadata.orderStatus < 3)) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      if (actualTripStartTime === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please enter actual trip start time"
              };
      }
      var value = Caml_option.valFromOption(actualTripStartTime);
      if (actualTripAcceptTime !== undefined) {
        if (Caml_obj.caml_greaterthan(value, metadata.currentTime)) {
          return {
                  TAG: /* Error */1,
                  _0: "Start trip time cannot be future time"
                };
        } else if (Caml_obj.caml_lessequal(value, Caml_option.valFromOption(actualTripAcceptTime))) {
          return {
                  TAG: /* Error */1,
                  _0: "Start trip time should be greater than trip accept time"
                };
        } else if (Caml_obj.caml_lessthan(value, metadata.order.created_at)) {
          return {
                  TAG: /* Error */1,
                  _0: "Trip start time cannot be less than order created time"
                };
        } else {
          return {
                  TAG: /* Ok */0,
                  _0: Caml_option.some(value)
                };
        }
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please enter trip accept time first"
              };
      }
    })
};

var validators_actualTripAcceptTime = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var actualTripAcceptTime = param.actualTripAcceptTime;
      if (!(metadata.isFormActive && metadata.orderStatus < 2)) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      if (actualTripAcceptTime === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please enter actual trip accept time"
              };
      }
      var value = Caml_option.valFromOption(actualTripAcceptTime);
      if (Caml_obj.caml_greaterthan(value, metadata.currentTime)) {
        return {
                TAG: /* Error */1,
                _0: "Accept trip time cannot be future time"
              };
      } else if (Caml_obj.caml_lessthan(value, metadata.order.created_at)) {
        return {
                TAG: /* Error */1,
                _0: "Accept trip time cannot be less than order created time"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(value)
              };
      }
    })
};

var validators_orderStatus = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var orderStatus = param.orderStatus;
      if (metadata.isFormActive && metadata.orderStatus < 7) {
        if (orderStatus !== undefined) {
          if (orderStatus.value === OrderStatus.toString(metadata.orderStatus)) {
            return {
                    TAG: /* Error */1,
                    _0: "Please change order status"
                  };
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: orderStatus.value
                  };
          }
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Please select order status"
                };
        }
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_msisdn = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var msisdn = param.msisdn;
      if (metadata.isFormActive && metadata.orderStatus < 2) {
        if (msisdn !== undefined) {
          return {
                  TAG: /* Ok */0,
                  _0: msisdn
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Please enter MSISDN"
                };
        }
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators = {
  manualUpdateReason: validators_manualUpdateReason,
  tripCompletedTime: validators_tripCompletedTime,
  tripEndTime: validators_tripEndTime,
  actualTripStartTime: validators_actualTripStartTime,
  actualTripAcceptTime: validators_actualTripAcceptTime,
  orderStatus: validators_orderStatus,
  msisdn: validators_msisdn
};

function initialFieldsStatuses(_input) {
  return {
          manualUpdateReason: /* Pristine */0,
          tripCompletedTime: /* Pristine */0,
          tripEndTime: /* Pristine */0,
          actualTripStartTime: /* Pristine */0,
          actualTripAcceptTime: /* Pristine */0,
          orderStatus: /* Pristine */0,
          msisdn: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.manualUpdateReason;
  var match_0 = match ? match._0 : Curry._2(validators.manualUpdateReason.validate, input, metadata);
  var match$1 = fieldsStatuses.tripCompletedTime;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.tripCompletedTime.validate, input, metadata);
  var match$2 = fieldsStatuses.tripEndTime;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.tripEndTime.validate, input, metadata);
  var match$3 = fieldsStatuses.actualTripStartTime;
  var match_0$3 = match$3 ? match$3._0 : Curry._2(validators.actualTripStartTime.validate, input, metadata);
  var match$4 = fieldsStatuses.actualTripAcceptTime;
  var match_0$4 = match$4 ? match$4._0 : Curry._2(validators.actualTripAcceptTime.validate, input, metadata);
  var match$5 = fieldsStatuses.orderStatus;
  var match_0$5 = match$5 ? match$5._0 : Curry._2(validators.orderStatus.validate, input, metadata);
  var match$6 = fieldsStatuses.msisdn;
  var match_0$6 = match$6 ? match$6._0 : Curry._2(validators.msisdn.validate, input, metadata);
  var manualUpdateReasonResult = match_0;
  var manualUpdateReasonResult$1;
  if (manualUpdateReasonResult.TAG === /* Ok */0) {
    var tripCompletedTimeResult = match_0$1;
    if (tripCompletedTimeResult.TAG === /* Ok */0) {
      var tripEndTimeResult = match_0$2;
      if (tripEndTimeResult.TAG === /* Ok */0) {
        var actualTripStartTimeResult = match_0$3;
        if (actualTripStartTimeResult.TAG === /* Ok */0) {
          var actualTripAcceptTimeResult = match_0$4;
          if (actualTripAcceptTimeResult.TAG === /* Ok */0) {
            var orderStatusResult = match_0$5;
            if (orderStatusResult.TAG === /* Ok */0) {
              var msisdnResult = match_0$6;
              if (msisdnResult.TAG === /* Ok */0) {
                return {
                        TAG: /* Valid */0,
                        output: {
                          msisdn: msisdnResult._0,
                          orderStatus: orderStatusResult._0,
                          actualTripAcceptTime: actualTripAcceptTimeResult._0,
                          actualTripStartTime: actualTripStartTimeResult._0,
                          tripEndTime: tripEndTimeResult._0,
                          tripCompletedTime: tripCompletedTimeResult._0,
                          manualUpdateReason: manualUpdateReasonResult._0
                        },
                        fieldsStatuses: {
                          manualUpdateReason: /* Dirty */{
                            _0: manualUpdateReasonResult,
                            _1: /* Shown */0
                          },
                          tripCompletedTime: /* Dirty */{
                            _0: tripCompletedTimeResult,
                            _1: /* Shown */0
                          },
                          tripEndTime: /* Dirty */{
                            _0: tripEndTimeResult,
                            _1: /* Shown */0
                          },
                          actualTripStartTime: /* Dirty */{
                            _0: actualTripStartTimeResult,
                            _1: /* Shown */0
                          },
                          actualTripAcceptTime: /* Dirty */{
                            _0: actualTripAcceptTimeResult,
                            _1: /* Shown */0
                          },
                          orderStatus: /* Dirty */{
                            _0: orderStatusResult,
                            _1: /* Shown */0
                          },
                          msisdn: /* Dirty */{
                            _0: msisdnResult,
                            _1: /* Shown */0
                          }
                        },
                        collectionsStatuses: undefined
                      };
              }
              manualUpdateReasonResult$1 = manualUpdateReasonResult;
            } else {
              manualUpdateReasonResult$1 = manualUpdateReasonResult;
            }
          } else {
            manualUpdateReasonResult$1 = manualUpdateReasonResult;
          }
        } else {
          manualUpdateReasonResult$1 = manualUpdateReasonResult;
        }
      } else {
        manualUpdateReasonResult$1 = manualUpdateReasonResult;
      }
    } else {
      manualUpdateReasonResult$1 = manualUpdateReasonResult;
    }
  } else {
    manualUpdateReasonResult$1 = manualUpdateReasonResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            manualUpdateReason: /* Dirty */{
              _0: manualUpdateReasonResult$1,
              _1: /* Shown */0
            },
            tripCompletedTime: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            tripEndTime: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            actualTripStartTime: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            actualTripAcceptTime: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            orderStatus: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            msisdn: /* Dirty */{
              _0: match_0$6,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurManualUpdateReasonField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.manualUpdateReason, validators_manualUpdateReason, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  manualUpdateReason: status,
                                  tripCompletedTime: init.tripCompletedTime,
                                  tripEndTime: init.tripEndTime,
                                  actualTripStartTime: init.actualTripStartTime,
                                  actualTripAcceptTime: init.actualTripAcceptTime,
                                  orderStatus: init.orderStatus,
                                  msisdn: init.msisdn
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTripCompletedTimeField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.tripCompletedTime, validators_tripCompletedTime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  manualUpdateReason: init.manualUpdateReason,
                                  tripCompletedTime: status,
                                  tripEndTime: init.tripEndTime,
                                  actualTripStartTime: init.actualTripStartTime,
                                  actualTripAcceptTime: init.actualTripAcceptTime,
                                  orderStatus: init.orderStatus,
                                  msisdn: init.msisdn
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTripEndTimeField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.tripEndTime, validators_tripEndTime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  manualUpdateReason: init.manualUpdateReason,
                                  tripCompletedTime: init.tripCompletedTime,
                                  tripEndTime: status,
                                  actualTripStartTime: init.actualTripStartTime,
                                  actualTripAcceptTime: init.actualTripAcceptTime,
                                  orderStatus: init.orderStatus,
                                  msisdn: init.msisdn
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurActualTripStartTimeField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.actualTripStartTime, validators_actualTripStartTime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  manualUpdateReason: init.manualUpdateReason,
                                  tripCompletedTime: init.tripCompletedTime,
                                  tripEndTime: init.tripEndTime,
                                  actualTripStartTime: status,
                                  actualTripAcceptTime: init.actualTripAcceptTime,
                                  orderStatus: init.orderStatus,
                                  msisdn: init.msisdn
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurActualTripAcceptTimeField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.actualTripAcceptTime, validators_actualTripAcceptTime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  manualUpdateReason: init.manualUpdateReason,
                                  tripCompletedTime: init.tripCompletedTime,
                                  tripEndTime: init.tripEndTime,
                                  actualTripStartTime: init.actualTripStartTime,
                                  actualTripAcceptTime: status,
                                  orderStatus: init.orderStatus,
                                  msisdn: init.msisdn
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurOrderStatusField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.orderStatus, validators_orderStatus, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  manualUpdateReason: init.manualUpdateReason,
                                  tripCompletedTime: init.tripCompletedTime,
                                  tripEndTime: init.tripEndTime,
                                  actualTripStartTime: init.actualTripStartTime,
                                  actualTripAcceptTime: init.actualTripAcceptTime,
                                  orderStatus: status,
                                  msisdn: init.msisdn
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMsisdnField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.msisdn, validators_msisdn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  manualUpdateReason: init.manualUpdateReason,
                                  tripCompletedTime: init.tripCompletedTime,
                                  tripEndTime: init.tripEndTime,
                                  actualTripStartTime: init.actualTripStartTime,
                                  actualTripAcceptTime: init.actualTripAcceptTime,
                                  orderStatus: init.orderStatus,
                                  msisdn: status
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */7 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */7,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */8,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */10);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */9);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */8 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */9 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */10 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateManualUpdateReasonField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.manualUpdateReason, state.submissionStatus, validators_manualUpdateReason, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            manualUpdateReason: status,
                                            tripCompletedTime: init.tripCompletedTime,
                                            tripEndTime: init.tripEndTime,
                                            actualTripStartTime: init.actualTripStartTime,
                                            actualTripAcceptTime: init.actualTripAcceptTime,
                                            orderStatus: init.orderStatus,
                                            msisdn: init.msisdn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTripCompletedTimeField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$7 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$1, metadata, nextFieldsStatuses.contents.tripEndTime, validators_tripEndTime, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  manualUpdateReason: init.manualUpdateReason,
                                  tripCompletedTime: init.tripCompletedTime,
                                  tripEndTime: status,
                                  actualTripStartTime: init.actualTripStartTime,
                                  actualTripAcceptTime: init.actualTripAcceptTime,
                                  orderStatus: init.orderStatus,
                                  msisdn: init.msisdn
                                };
                        }));
                  if (result$7 !== undefined) {
                    nextFieldsStatuses.contents = result$7;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, nextFieldsStatuses.contents.tripCompletedTime, state.submissionStatus, validators_tripCompletedTime, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            manualUpdateReason: init.manualUpdateReason,
                                            tripCompletedTime: status,
                                            tripEndTime: init.tripEndTime,
                                            actualTripStartTime: init.actualTripStartTime,
                                            actualTripAcceptTime: init.actualTripAcceptTime,
                                            orderStatus: init.orderStatus,
                                            msisdn: init.msisdn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTripEndTimeField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = {
                    contents: state.fieldsStatuses
                  };
                  var result$8 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$2, metadata, nextFieldsStatuses$1.contents.tripCompletedTime, validators_tripCompletedTime, (function (status) {
                          var init = nextFieldsStatuses$1.contents;
                          return {
                                  manualUpdateReason: init.manualUpdateReason,
                                  tripCompletedTime: status,
                                  tripEndTime: init.tripEndTime,
                                  actualTripStartTime: init.actualTripStartTime,
                                  actualTripAcceptTime: init.actualTripAcceptTime,
                                  orderStatus: init.orderStatus,
                                  msisdn: init.msisdn
                                };
                        }));
                  if (result$8 !== undefined) {
                    nextFieldsStatuses$1.contents = result$8;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, nextFieldsStatuses$1.contents.tripEndTime, state.submissionStatus, validators_tripEndTime, (function (status) {
                                    var init = nextFieldsStatuses$1.contents;
                                    return {
                                            manualUpdateReason: init.manualUpdateReason,
                                            tripCompletedTime: init.tripCompletedTime,
                                            tripEndTime: status,
                                            actualTripStartTime: init.actualTripStartTime,
                                            actualTripAcceptTime: init.actualTripAcceptTime,
                                            orderStatus: init.orderStatus,
                                            msisdn: init.msisdn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateActualTripStartTimeField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$2 = {
                    contents: state.fieldsStatuses
                  };
                  var result$9 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$3, metadata, nextFieldsStatuses$2.contents.actualTripAcceptTime, validators_actualTripAcceptTime, (function (status) {
                          var init = nextFieldsStatuses$2.contents;
                          return {
                                  manualUpdateReason: init.manualUpdateReason,
                                  tripCompletedTime: init.tripCompletedTime,
                                  tripEndTime: init.tripEndTime,
                                  actualTripStartTime: init.actualTripStartTime,
                                  actualTripAcceptTime: status,
                                  orderStatus: init.orderStatus,
                                  msisdn: init.msisdn
                                };
                        }));
                  if (result$9 !== undefined) {
                    nextFieldsStatuses$2.contents = result$9;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, nextFieldsStatuses$2.contents.actualTripStartTime, state.submissionStatus, validators_actualTripStartTime, (function (status) {
                                    var init = nextFieldsStatuses$2.contents;
                                    return {
                                            manualUpdateReason: init.manualUpdateReason,
                                            tripCompletedTime: init.tripCompletedTime,
                                            tripEndTime: init.tripEndTime,
                                            actualTripStartTime: status,
                                            actualTripAcceptTime: init.actualTripAcceptTime,
                                            orderStatus: init.orderStatus,
                                            msisdn: init.msisdn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateActualTripAcceptTimeField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$3 = {
                    contents: state.fieldsStatuses
                  };
                  var result$10 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$4, metadata, nextFieldsStatuses$3.contents.actualTripStartTime, validators_actualTripStartTime, (function (status) {
                          var init = nextFieldsStatuses$3.contents;
                          return {
                                  manualUpdateReason: init.manualUpdateReason,
                                  tripCompletedTime: init.tripCompletedTime,
                                  tripEndTime: init.tripEndTime,
                                  actualTripStartTime: status,
                                  actualTripAcceptTime: init.actualTripAcceptTime,
                                  orderStatus: init.orderStatus,
                                  msisdn: init.msisdn
                                };
                        }));
                  if (result$10 !== undefined) {
                    nextFieldsStatuses$3.contents = result$10;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, nextFieldsStatuses$3.contents.actualTripAcceptTime, state.submissionStatus, validators_actualTripAcceptTime, (function (status) {
                                    var init = nextFieldsStatuses$3.contents;
                                    return {
                                            manualUpdateReason: init.manualUpdateReason,
                                            tripCompletedTime: init.tripCompletedTime,
                                            tripEndTime: init.tripEndTime,
                                            actualTripStartTime: init.actualTripStartTime,
                                            actualTripAcceptTime: status,
                                            orderStatus: init.orderStatus,
                                            msisdn: init.msisdn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateOrderStatusField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.orderStatus, state.submissionStatus, validators_orderStatus, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            manualUpdateReason: init.manualUpdateReason,
                                            tripCompletedTime: init.tripCompletedTime,
                                            tripEndTime: init.tripEndTime,
                                            actualTripStartTime: init.actualTripStartTime,
                                            actualTripAcceptTime: init.actualTripAcceptTime,
                                            orderStatus: status,
                                            msisdn: init.msisdn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMsisdnField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$6, metadata, state.fieldsStatuses.msisdn, state.submissionStatus, validators_msisdn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            manualUpdateReason: init.manualUpdateReason,
                                            tripCompletedTime: init.tripCompletedTime,
                                            tripEndTime: init.tripEndTime,
                                            actualTripStartTime: init.actualTripStartTime,
                                            actualTripAcceptTime: init.actualTripAcceptTime,
                                            orderStatus: init.orderStatus,
                                            msisdn: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */7 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */8 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */9 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateManualUpdateReason: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateManualUpdateReasonField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTripCompletedTime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTripCompletedTimeField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTripEndTime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTripEndTimeField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateActualTripStartTime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateActualTripStartTimeField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateActualTripAcceptTime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateActualTripAcceptTimeField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateOrderStatus: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateOrderStatusField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMsisdn: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMsisdnField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurManualUpdateReason: (function (param) {
              return Curry._1(dispatch, /* BlurManualUpdateReasonField */0);
            }),
          blurTripCompletedTime: (function (param) {
              return Curry._1(dispatch, /* BlurTripCompletedTimeField */1);
            }),
          blurTripEndTime: (function (param) {
              return Curry._1(dispatch, /* BlurTripEndTimeField */2);
            }),
          blurActualTripStartTime: (function (param) {
              return Curry._1(dispatch, /* BlurActualTripStartTimeField */3);
            }),
          blurActualTripAcceptTime: (function (param) {
              return Curry._1(dispatch, /* BlurActualTripAcceptTimeField */4);
            }),
          blurOrderStatus: (function (param) {
              return Curry._1(dispatch, /* BlurOrderStatusField */5);
            }),
          blurMsisdn: (function (param) {
              return Curry._1(dispatch, /* BlurMsisdnField */6);
            }),
          manualUpdateReasonResult: Formality.exposeFieldResult(state.fieldsStatuses.manualUpdateReason),
          tripCompletedTimeResult: Formality.exposeFieldResult(state.fieldsStatuses.tripCompletedTime),
          tripEndTimeResult: Formality.exposeFieldResult(state.fieldsStatuses.tripEndTime),
          actualTripStartTimeResult: Formality.exposeFieldResult(state.fieldsStatuses.actualTripStartTime),
          actualTripAcceptTimeResult: Formality.exposeFieldResult(state.fieldsStatuses.actualTripAcceptTime),
          orderStatusResult: Formality.exposeFieldResult(state.fieldsStatuses.orderStatus),
          msisdnResult: Formality.exposeFieldResult(state.fieldsStatuses.msisdn),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.manualUpdateReason || match.tripCompletedTime || match.tripEndTime || match.actualTripStartTime || match.actualTripAcceptTime || match.orderStatus || match.msisdn) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */7);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */8);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */9);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */9,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */10);
            })
        };
}

var OrderStatusForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getPayload(formData, crn, order_updated_at, currentOrderStatus) {
  if (formData === undefined) {
    return ;
  }
  var reason = formData.manualUpdateReason;
  var time = formData.actualTripAcceptTime;
  var time$1 = formData.actualTripStartTime;
  var time$2 = formData.tripEndTime;
  var time$3 = formData.tripCompletedTime;
  return {
          manual_update_reason_id: reason !== undefined ? Caml_format.caml_int_of_string(reason) : -1,
          final_order_status: Belt_Option.getWithDefault(formData.orderStatus, ""),
          current_order_status: OrderStatus.toString(currentOrderStatus),
          order_updated_at: order_updated_at,
          crn: crn,
          uuid: undefined,
          msisdn: formData.msisdn,
          trip_accepted_time: time !== undefined ? Timestamp$Catalyst.toFloat(Caml_option.valFromOption(time)) : undefined,
          trip_started_time: time$1 !== undefined ? Timestamp$Catalyst.toFloat(Caml_option.valFromOption(time$1)) : undefined,
          trip_ended_time: time$2 !== undefined ? Timestamp$Catalyst.toFloat(Caml_option.valFromOption(time$2)) : undefined,
          job_ended_time: time$3 !== undefined ? Timestamp$Catalyst.toFloat(Caml_option.valFromOption(time$3)) : undefined
        };
}

function getDefaultFormInput(param) {
  return {
          msisdn: undefined,
          orderStatus: undefined,
          actualTripAcceptTime: undefined,
          actualTripStartTime: undefined,
          tripEndTime: undefined,
          tripCompletedTime: undefined,
          manualUpdateReason: undefined
        };
}

function getInitialInput(orderDetails, orderStatus) {
  var exit = 0;
  switch (orderStatus) {
    case /* Open */0 :
    case /* Allocated */1 :
        exit = 1;
        break;
    case /* Accepted */2 :
        if (orderDetails.TAG !== /* Accepted */1) {
          return {
                  msisdn: undefined,
                  orderStatus: undefined,
                  actualTripAcceptTime: undefined,
                  actualTripStartTime: undefined,
                  tripEndTime: undefined,
                  tripCompletedTime: undefined,
                  manualUpdateReason: undefined
                };
        }
        var acceptedOrder = orderDetails._1;
        var value = OrderStatus.toString(orderDetails._0.status);
        return {
                msisdn: acceptedOrder.partner_info.msisdn,
                orderStatus: SelectComponent$Catalyst.getSelectedItem(value, getUpdateOrderStatusSelectData(orderStatus)),
                actualTripAcceptTime: acceptedOrder.trip_accepted_time,
                actualTripStartTime: undefined,
                tripEndTime: undefined,
                tripCompletedTime: undefined,
                manualUpdateReason: undefined
              };
    case /* Live */3 :
    case /* Loading */4 :
    case /* Unloading */5 :
        exit = 2;
        break;
    case /* Ended */6 :
        if (orderDetails.TAG !== /* Ended */3) {
          return {
                  msisdn: undefined,
                  orderStatus: undefined,
                  actualTripAcceptTime: undefined,
                  actualTripStartTime: undefined,
                  tripEndTime: undefined,
                  tripCompletedTime: undefined,
                  manualUpdateReason: undefined
                };
        }
        var acceptedOrder$1 = orderDetails._1;
        var value$1 = OrderStatus.toString(orderDetails._0.status);
        return {
                msisdn: acceptedOrder$1.partner_info.msisdn,
                orderStatus: SelectComponent$Catalyst.getSelectedItem(value$1, getUpdateOrderStatusSelectData(orderStatus)),
                actualTripAcceptTime: acceptedOrder$1.trip_accepted_time,
                actualTripStartTime: Caml_option.some(orderDetails._2.trip_started_time),
                tripEndTime: Caml_option.some(orderDetails._3.trip_end_time),
                tripCompletedTime: undefined,
                manualUpdateReason: undefined
              };
    case /* Completed */7 :
        if (orderDetails.TAG !== /* Ended */3) {
          return {
                  msisdn: undefined,
                  orderStatus: undefined,
                  actualTripAcceptTime: undefined,
                  actualTripStartTime: undefined,
                  tripEndTime: undefined,
                  tripCompletedTime: undefined,
                  manualUpdateReason: undefined
                };
        }
        var endedOrder = orderDetails._3;
        var acceptedOrder$2 = orderDetails._1;
        var value$2 = OrderStatus.toString(orderDetails._0.status);
        return {
                msisdn: acceptedOrder$2.partner_info.msisdn,
                orderStatus: SelectComponent$Catalyst.getSelectedItem(value$2, getUpdateOrderStatusSelectData(orderStatus)),
                actualTripAcceptTime: acceptedOrder$2.trip_accepted_time,
                actualTripStartTime: Caml_option.some(orderDetails._2.trip_started_time),
                tripEndTime: Caml_option.some(endedOrder.trip_end_time),
                tripCompletedTime: endedOrder.job_end_time,
                manualUpdateReason: undefined
              };
    case /* Cancelled */8 :
        switch (orderDetails.TAG | 0) {
          case /* Cancelled */4 :
              var partnerInfo = orderDetails._1.partner_info;
              var value$3 = OrderStatus.toString(orderDetails._0.status);
              return {
                      msisdn: partnerInfo !== undefined ? partnerInfo.msisdn : undefined,
                      orderStatus: SelectComponent$Catalyst.getSelectedItem(value$3, getUpdateOrderStatusSelectData(orderStatus)),
                      actualTripAcceptTime: undefined,
                      actualTripStartTime: undefined,
                      tripEndTime: undefined,
                      tripCompletedTime: undefined,
                      manualUpdateReason: undefined
                    };
          case /* CancelledAccepted */5 :
              var acceptedOrder$3 = orderDetails._2;
              var value$4 = OrderStatus.toString(orderDetails._0.status);
              return {
                      msisdn: acceptedOrder$3.partner_info.msisdn,
                      orderStatus: SelectComponent$Catalyst.getSelectedItem(value$4, getUpdateOrderStatusSelectData(orderStatus)),
                      actualTripAcceptTime: acceptedOrder$3.trip_accepted_time,
                      actualTripStartTime: undefined,
                      tripEndTime: undefined,
                      tripCompletedTime: undefined,
                      manualUpdateReason: undefined
                    };
          case /* CancelledLive */6 :
              var acceptedOrder$4 = orderDetails._2;
              var value$5 = OrderStatus.toString(orderDetails._0.status);
              return {
                      msisdn: acceptedOrder$4.partner_info.msisdn,
                      orderStatus: SelectComponent$Catalyst.getSelectedItem(value$5, getUpdateOrderStatusSelectData(orderStatus)),
                      actualTripAcceptTime: acceptedOrder$4.trip_accepted_time,
                      actualTripStartTime: Caml_option.some(orderDetails._3.trip_started_time),
                      tripEndTime: undefined,
                      tripCompletedTime: undefined,
                      manualUpdateReason: undefined
                    };
          default:
            return {
                    msisdn: undefined,
                    orderStatus: undefined,
                    actualTripAcceptTime: undefined,
                    actualTripStartTime: undefined,
                    tripEndTime: undefined,
                    tripCompletedTime: undefined,
                    manualUpdateReason: undefined
                  };
        }
    case /* Rescheduled */9 :
        return {
                msisdn: undefined,
                orderStatus: undefined,
                actualTripAcceptTime: undefined,
                actualTripStartTime: undefined,
                tripEndTime: undefined,
                tripCompletedTime: undefined,
                manualUpdateReason: undefined
              };
    
  }
  switch (exit) {
    case 1 :
        if (orderDetails.TAG !== /* Open */0) {
          return {
                  msisdn: undefined,
                  orderStatus: undefined,
                  actualTripAcceptTime: undefined,
                  actualTripStartTime: undefined,
                  tripEndTime: undefined,
                  tripCompletedTime: undefined,
                  manualUpdateReason: undefined
                };
        }
        var value$6 = OrderStatus.toString(orderDetails._0.status);
        return {
                msisdn: undefined,
                orderStatus: SelectComponent$Catalyst.getSelectedItem(value$6, getUpdateOrderStatusSelectData(orderStatus)),
                actualTripAcceptTime: undefined,
                actualTripStartTime: undefined,
                tripEndTime: undefined,
                tripCompletedTime: undefined,
                manualUpdateReason: undefined
              };
    case 2 :
        if (orderDetails.TAG !== /* Live */2) {
          return {
                  msisdn: undefined,
                  orderStatus: undefined,
                  actualTripAcceptTime: undefined,
                  actualTripStartTime: undefined,
                  tripEndTime: undefined,
                  tripCompletedTime: undefined,
                  manualUpdateReason: undefined
                };
        }
        var acceptedOrder$5 = orderDetails._1;
        var value$7 = OrderStatus.toString(orderDetails._0.status);
        return {
                msisdn: acceptedOrder$5.partner_info.msisdn,
                orderStatus: SelectComponent$Catalyst.getSelectedItem(value$7, getUpdateOrderStatusSelectData(orderStatus)),
                actualTripAcceptTime: acceptedOrder$5.trip_accepted_time,
                actualTripStartTime: Caml_option.some(orderDetails._2.trip_started_time),
                tripEndTime: undefined,
                tripCompletedTime: undefined,
                manualUpdateReason: undefined
              };
    
  }
}

var OrderStatusFormHelper = {
  getPayload: getPayload,
  getDefaultFormInput: getDefaultFormInput,
  getInitialInput: getInitialInput
};

export {
  isMsisdnEnabled ,
  isOrderStatusEnabled ,
  isActualTripAcceptTimeEnabled ,
  isActualTripStartTimeEnabled ,
  isEndTimeEnabled ,
  isCompletedTimeEnabled ,
  isManualUpdateReasonEnabled ,
  makeUpdateOrderStatusSelectComponentList ,
  getUpdateOrderStatusSelectData ,
  getOrderStatusDropdownItem ,
  OrderStatusForm ,
  OrderStatusFormHelper ,
  
}
/* react Not a pure module */
